"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NextLink = _interopRequireDefault(require("./templates/NextLink"));
var _AnchorLink = _interopRequireDefault(require("./templates/AnchorLink"));
var _envConstants = require("../../env-constants");
var Link = function Link(props) {
  var IS_NEXT = _envConstants.ENV.IS_NEXT,
    API_URL = _envConstants.ENV.API_URL,
    SITE = _envConstants.ENV.SITE;

  // If we're not in a next environment then we always use anchor
  if (!IS_NEXT || props.href.charAt(0) === '#') {
    return /*#__PURE__*/_react["default"].createElement(_AnchorLink["default"], props);
  }
  var href = props.href;
  var pathname = '/';

  // Check if first character is / and second character isn't.
  // If not, get the path from url with js URL class
  if (href.charAt(0) === '/' && href.charAt(1) !== '/') {
    var target = new URL("".concat(API_URL).concat(href));
    pathname = target.pathname || '/';
  } else {
    if (href.substring(0, 1) === '//') {
      // Just using '//www.theyachtweek.com' is not valid in JS class URL
      href = "https:".concat(href);
    }
    if (href === '') {
      href = API_URL;
    }

    // https://nodejs.org/docs/latest-v8.x/api/url.html
    var _target = new URL(href);
    var hostname = _target.hostname;
    var protocol = _target.protocol;
    pathname = _target.pathname;

    // In case we're using mailto: or tel: or something
    if (!['https:', 'http:'].includes(protocol)) {
      return /*#__PURE__*/_react["default"].createElement(_AnchorLink["default"], props);
    }

    // Base path for the site we're in eg. www.theyachtweek.com or tyw.lh
    var baseHostname = new URL(API_URL).hostname;

    // Check if it's a url on the same site. If not then anchor. This will include all cdn links too
    if (!(hostname === baseHostname || hostname.substring(0, 3) === 'www.' && hostname.substring(4) === baseHostname || baseHostname.substring(0, 3) === 'www.' && baseHostname.substring(4) === hostname)) {
      return /*#__PURE__*/_react["default"].createElement(_AnchorLink["default"], props);
    }
  }

  // It's the same site so we can mimic our nginx setup

  // First character should always be '/' here so get index 1 from array
  var rootPath = pathname.split('/')[1];
  var symfonyRoutes = {
    tyw: ['country-manager', 'admin', 'api', 'browse', 'paylink', 'account', 'connect', 'booking', 'arrival-info', 'cabins-invitation', 'invitation', 'partner', 'check-in', 'plan', 'planner', 'cabin-booking', 'terms-and-conditions', 'tour-operator-terms-and-conditions', 'agent-terms-and-conditions', 'react', 'loveboat'],
    tsw: ['admin', 'api', 'flats', 'book', 'account', 'connect', 'booking', 'check-in', 'book-now', 'apartments', 'invitation', '__preview', 'cms-uploads', 'terms-and-conditions', 'old'],
    ynf: [],
    day8: [],
    qd: []
  };

  // check if it matches a symfony route and use anchor if so
  if (symfonyRoutes[SITE].includes(rootPath)) {
    return /*#__PURE__*/_react["default"].createElement(_AnchorLink["default"], props);
  }

  // Else we should be able to use nextLink.
  // Would prefer to fallback to anchor but this has to match
  // nginx config so important that previous checks are correct

  return /*#__PURE__*/_react["default"].createElement(_NextLink["default"], (0, _extends2["default"])({}, props, {
    href: pathname
  }));
};
Link.propTypes = {
  href: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Link;